// STYLES
import * as Style from "./TabsStyle";

// LIBRARIES

// MISC
import { TabsData } from "./TabsModel";
import { ButtonTypes } from "models/GeneralTypes/generalTypes";

// ASSETS

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { handleResetFiltersState } from "slices/filtersSlice";
import {
  auditTabs, invoicesTabs, reportsTabs, selectedTab, toggleActiveTab
} from "slices/uiSlice";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";

const TabsComponent = () => {
  // PROPS
  const { reportsTabsEntries, auditTabsEntries, invoicesTabsEntries } = TabsData();

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector<string>(selectedTab);
  const reportsTabsValue = useAppSelector<boolean>(reportsTabs);
  const invoicesTabsValue = useAppSelector<boolean>(invoicesTabs);
  const auditTabsValue = useAppSelector<boolean>(auditTabs);

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleActiveTab = (path) => {
    dispatch(handleResetFiltersState());
    dispatch(toggleActiveTab(path));
  };

  return (
    <Style.ReportsTabsContainer>
      {reportsTabsValue &&
        reportsTabsEntries.map((tab) => {
          return (
            <Style.ButtonContainer>
              <ButtonAtom
                text={tab?.title}
                onClick={() => activeTab !== tab.path ? handleActiveTab(tab.path) : {}}
                type={activeTab === tab.path ? ButtonTypes.SECONDARY_BUTTON_DEFAULT : ButtonTypes.SECONDARY_BUTTON_INACTIVE}
              />
            </Style.ButtonContainer>
          );
        })}
      {invoicesTabsValue &&
        invoicesTabsEntries.map((tab) => {
          return (
            <Style.ButtonContainer>
              <ButtonAtom
                text={tab?.title}
                onClick={() => activeTab !== tab.path ? handleActiveTab(tab.path) : {}}
                type={activeTab === tab.path ? ButtonTypes.SECONDARY_BUTTON_DEFAULT : ButtonTypes.SECONDARY_BUTTON_INACTIVE}
              />
            </Style.ButtonContainer>
          );
        })}
      {auditTabsValue &&
        auditTabsEntries.map((tab) => {
          return (
            <Style.ButtonContainer>
              <ButtonAtom
                text={tab?.title}
                onClick={() => activeTab !== tab.path ? handleActiveTab(tab.path) : {}}
                type={activeTab === tab.path ? ButtonTypes.SECONDARY_BUTTON_DEFAULT : ButtonTypes.SECONDARY_BUTTON_INACTIVE}
              />
            </Style.ButtonContainer>
          );
        })}
    </Style.ReportsTabsContainer>
  );
};

export default TabsComponent;
